import React, { useEffect, useState } from "react";
import styled from "styled-components";
import colors from "styles/colors";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import googleSelectors from "modules/google/selectors";
import googleActions from "modules/google/actions";
import googleHelper from "../../helper/google";

const GoogleSigninButton = ({ googleStatus }) => {
  const rmpToken = sessionStorage.getItem("rmp_token");
  const dispatch = useDispatch();
  const [t] = useTranslation();
  const { REACT_APP_GOOGLE_LEADS_API_CLIENT_ID } = process.env;
  let client;
  const leadFormId = localStorage.getItem("leadFormId");
  const googleDisconnectedResult = useSelector((state) => googleSelectors.setGoogleLeadGoogleDisconnectedResult(state));

  const handleCredentialResponse = async (response) => {
    console.log("handleCredentialResponse", response);
  };

  useEffect(() => {
    const lang = sessionStorage.getItem("lang") ? sessionStorage.getItem("lang") : "en";

    google.accounts.id.initialize({
      client_id: REACT_APP_GOOGLE_LEADS_API_CLIENT_ID,
      callback: handleCredentialResponse,
    });
    google.accounts.id.renderButton(document.getElementById("google_signin_button"), {
      theme: "filled_blue",
      size: "large",
      width: 250,
      locale: lang,
    });
  }, []);

  /**
   * action after click google sign in button
   * use code from google to get refresh token
   * and get google data (right side of setting modal)
   * @param {*} code
   */
  const googleExchangeToken = async (code) => {
    await dispatch(googleActions.setGoogleLoading(true));
    const googleSetting = await dispatch(
      googleActions.getGoogleSheetsSetting({
        token: rmpToken,
        id: leadFormId,
      }),
    );
    const exchangeToken = await dispatch(
      googleActions.getGoogleExchangeToken({
        token: rmpToken,
        code: code,
      }),
    );
    sessionStorage.removeItem("google_access_token");

    if (exchangeToken.result === 0) {
      await dispatch(googleActions.setGoogleLeadGoogleConnected(true));
      await dispatch(googleActions.setValidateGGLeadsGoogleSheetsUrl({ result: false }));
      let googleSheetsUrl = "";
      if (
        !googleDisconnectedResult.data.googleDisconnected &&
        googleSetting.result === 0 &&
        googleSetting.msg === "GET_DATA_COMPLETED" &&
        googleSetting.data &&
        googleSetting.data.google_sheets_message_error === "token_expire"
      ) {
        googleSheetsUrl = googleSetting.data.spreadsheet_url;
      }

      await dispatch(
        googleActions.getGoogleSheetsList({
          token: rmpToken,
          refreshToken: exchangeToken.data.tokens.refresh_token,
          googleAccount: exchangeToken.data.googleAccount.google_account,
          spreadsheetUrl: googleSheetsUrl,
        }),
      );
      await dispatch(googleActions.changeGoogleLeadSheetsUrlInput(googleSheetsUrl));
      sessionStorage.setItem("google_access_token", exchangeToken.data.tokens.access_token);
      await dispatch(googleActions.setGoogleLoading(false));
    } else {
      await dispatch(googleActions.setGoogleLoading(false));
    }
  };

  const Auth = async () => {
    try {
      const initTokenResult = await googleHelper.initClientToken();
      googleExchangeToken(initTokenResult.code);
    } catch (error) {
      console.log("Auth Error: ", error.message);
    }
  };

  const ErrorMessage = () => {
    return (
      <MessageError className="error-message">
        <div>{t("__connection_problem")}</div>
        <div>{t("__connection_try_again")}</div>
      </MessageError>
    );
  };

  return (
    <>
      <SiginContainer>
        {googleStatus === "error" ? (
          <ErrorMessage />
        ) : (
          <div className="login-description">{t("__fbleads_google_connect")}</div>
        )}
        <SigninButtonContainer>
          <AuthDummyButton onClick={Auth}></AuthDummyButton>
          <div id="google_signin_button" className="sign-in"></div>
        </SigninButtonContainer>
      </SiginContainer>
    </>
  );
};

export default GoogleSigninButton;

const SiginContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  .login-description {
    font-size: 14px;
    color: #aaa;
    margin-bottom: 5px;
    text-align: center;
    .error-message {
      color: ${colors.negative};
    }
  }
`;

const SigninButtonContainer = styled.div`
  position: relative;

  @media screen and (max-width: 834px) {
    display: flex;
    justify-content: center;
    flex-direction: column;
  }
`;

const AuthDummyButton = styled.div`
  z-index: 1;
  position: absolute;
  width: 100%;
  height: 100%;
  cursor: pointer;
`;

const MessageError = styled.div`
  color: ${colors.negative};
  font-size: 14px;
  text-align: center;
  line-height: 1.5rem;
  margin-bottom: 5px;
`;
